import React from "react";
import { Dialog, DialogContent, Box } from "@material-ui/core";
import { getConfigTenant, isCorpTenant } from "@capone/common";
import {
  Icon,
  IconName,
  CorporateTypography,
  CloseButton,
  CorporateButton,
} from "halifax";
import "./styles.scss";

interface IMultiAdultPassengerModalProps {
  open: boolean;
  onClose: () => void;
  onEditTravelers: () => void;
}

export const MultiAdultPassengerModal: React.FC<
  IMultiAdultPassengerModalProps
> = ({ open, onClose, onEditTravelers }) => {
  const isCorporate = isCorpTenant(getConfigTenant());

  if (!isCorporate) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        className: "multi-adult-passenger-modal",
      }}
    >
      <CloseButton onClick={onClose} />
      <DialogContent className="multi-adult-passenger-modal-content">
        <Box>
          <Icon name={IconName.CorpLightbulbModal} />
        </Box>
        <CorporateTypography variant="h2">
          Hotels + flights only supports 1 hotel room per booking
        </CorporateTypography>
        <CorporateTypography variant="body1">
          You can continue with multiple travelers if you plan to share a room.
          If you'd like to book more than 1 room, you can use hotels + flights
          for 1 room at a time or book your hotel and flight separately.
        </CorporateTypography>
        <Box>
          <CorporateButton
            variant="outlined"
            size="small"
            onClick={onEditTravelers}
          >
            Edit travelers
          </CorporateButton>
          <CorporateButton variant="contained" size="small" onClick={onClose}>
            Continue
          </CorporateButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
